import React from "react";
import { Item, MenuItem } from "../../../../components/Menu";
import { LocalizationMessages } from "../../../../localization/messages";
import { UISelectors } from "../../../../redux/selectors";
import { UrlUtils } from "../../../../utils";
import { useSelector } from "react-redux";

export const ResponsibleGamingMenuItem = () => {
  const links = useSelector(UISelectors.links);

  const responsibleGamingItem = new Item({
    URL: UrlUtils.getNativeLink(links.responsibleGamingExternal),
    title: LocalizationMessages.responsibleGamingExternal,
    iconKey: "green-gaming",
    target: "_blank"
  });

  return (
    <MenuItem
      item={responsibleGamingItem}
      dataTestId="uc-responsible-gaming"
      ignoreNavigation={true}
    />
  );
};
